import { render, staticRenderFns } from "./ProductViewSearch.template.vue?vue&type=template&id=a1d792d8&scoped=true&"
var script = {}
import style0 from "./ProductViewSearch.template.vue?vue&type=style&index=0&id=a1d792d8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d792d8",
  null
  
)

export default component.exports